export const shortestPathNodes = [
  {
    id: "194.200.5.136",
    type: "custom",
    position: { x: 85, y: 130 },
    className: "notebook",
    data: { label: "194.200.5.136" },
    dragHandle: "noDrag",
  },
  {
    id: "102.80.143.201",
    type: "default",
    position: { x: 290, y: 150 },
    className: "gateway",
    data: { label: "102.80.143.201" },
    dragHandle: "noDrag",
  },
  {
    id: "10.5.112.134",
    type: "default",
    position: { x: 530, y: 215 },
    className: "gateway",
    data: { label: "10.5.112.134" },
    dragHandle: "noDrag",
  },
  {
    id: "71.20.12.201",
    type: "default",
    position: { x: 790, y: 90 },
    className: "gateway",
    data: { label: "71.20.12.201" },
    dragHandle: "noDrag",
  },
  {
    id: "135.156.222.108",
    type: "default",
    position: { x: 690, y: 300 },
    className: "gateway",
    data: { label: "135.156.222.108" },
    dragHandle: "noDrag",
  },
  {
    id: "48.189.46.255",
    type: "default",
    position: { x: 840, y: 513 },
    className: "gateway",
    data: { label: "48.189.46.255" },
    dragHandle: "noDrag",
  },
  {
    id: "25.44.79.53",
    type: "default",
    position: { x: 390, y: 390 },
    className: "gateway",
    data: { label: "25.44.79.53" },
    dragHandle: "noDrag",
  },
  {
    id: "172.251.238.79",
    type: "default",
    position: { x: 590, y: 546 },
    className: "gateway",
    data: { label: "172.251.238.79" },
    dragHandle: "noDrag",
  },
  {
    id: "2.133.220.187",
    type: "default",
    position: { x: 190, y: 300 },
    className: "gateway",
    data: { label: "2.133.220.187" },
    dragHandle: "noDrag",
  },
  {
    id: "159.199.179.144",
    type: "default",
    position: { x: 240, y: 500 },
    className: "gateway",
    data: { label: "159.199.179.144" },
    dragHandle: "noDrag",
  },
  {
    id: "51.247.206.27",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 900, y: 300 },
    className: "server-plain non-draggable",
    data: { label: "51.247.206.27" },
  },
];
